<div class="loading-container flex-centred-content">
	<div class="nsw-loader">
		<span aria-hidden="true" class="nsw-loader__circle nsw-loader__circle--lg"></span>
	</div>	
</div>

